import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { wlApi } from "../lib/wlApi";

const WLAuthContext = createContext(null);

export const WLAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await wlApi.get("/auth/me");
      setUser(data.user);
      setStore(data.store);
      return data;
    } catch {
      setUser(false);
      setStore(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const location = useLocation();
  const [checked, setChecked] = useState(false);
  const isWLRoute = /^\/(white-label|admin\/white-label|a\/)/.test(location.pathname);

  useEffect(() => {
    if (checked) return;
    if (isWLRoute) {
      setChecked(true);
      refresh();
    } else {
      setLoading(false);
    }
  }, [isWLRoute, checked, refresh]);

  const logout = async () => {
    try { await wlApi.post("/auth/logout"); } catch (e) { console.debug(e?.message); }
    setUser(false);
    setStore(null);
  };

  return (
    <WLAuthContext.Provider value={{ user, store, loading, refresh, logout, setUser, setStore }}>
      {children}
    </WLAuthContext.Provider>
  );
};

export const useWLAuth = () => useContext(WLAuthContext);
